import { render, staticRenderFns } from "./beginCatMsgBox.vue?vue&type=template&id=2483a30c&scoped=true&"
import script from "./beginCatMsgBox.vue?vue&type=script&lang=js&"
export * from "./beginCatMsgBox.vue?vue&type=script&lang=js&"
import style0 from "./beginCatMsgBox.vue?vue&type=style&index=0&id=2483a30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483a30c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
